import type { ReactElement } from 'react';
import type { RichLinkProps } from '@naf-simba/sections-rich-link';

interface ImageProps {
  src: string;
  alt: string;
}

export const getMediaProps = (advancedImage?: ReactElement, imgProp?: ImageProps): RichLinkProps['media'] => {
  if (advancedImage) {
    return { render: () => advancedImage };
  }
  if (imgProp) {
    return { src: imgProp.src, alt: imgProp.alt };
  }
  return undefined;
};
